import styled from 'styled-components';
import Theme from '../../../styles/models/theme';

export const Container = styled.div<{theme: Theme; size: number}>`
  width: ${({size}) => `${size}px`};
  height: ${({size}) => `${size}px`};
  border-radius: ${({size}) => `${size / 2}px`};
  background-color: ${({theme}) => theme.primary};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.text<{theme: Theme; size: number}>`
  font-weight: 500;
  font-size: ${({size}) => `${size - 6}px`};
  color: ${({theme}) => theme.lightText};
`;
